import React, { Component } from 'react';
import Slider from "react-slick";
import { ShrinkBox } from '../../components'
import { Link } from 'react-router-dom';
import './styles.scss'

class ReferenceDesktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedThumbnail: 0,
      selectedArray: [
        {
          activation: '',
          title: '',
          text: '',
          products: [],
          thumbs: [],
        },
      ],
      rehabilitationArray: [
        {
          activation: 'rehabilitation',
          title: 'Рехабилитация на пътя между Враца и пещерата „Леденика“',
          backbutton: 'Рехабилитация на пътя между Враца и пещерата „Леденика“',
          text: 'На 28 септември 2017г. стартира рехабилитацията на пътя Враца – пещера " Леденика ". Рехабилитацията на 17- километровия участък е част от първите приоритетни обекти на Оперативна програма "Региони в растеж" 2014 - 2020. На този обект са приложени специализирани поръчкови каломаслоуловители с байпасно устройство HYDROOIL BYPASS.',
          products: [
            { name: 'Каломаслоуловител HYDROOIL BYPASS NS 6-30 l/s.', link: '/solution/hydrooil-bypass' },
            { name: 'Каломаслоуловител HYDROOIL BYPASS NS 15-75 l/s.', link: '/solution/hydrooil-bypass' },
          ],
          thumbs: [
            { image: '/references/reference-rehabilitation-1-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-rehabilitation-1.jpg' },
          ],
          backgroundImage: '/references/reference-rehabilitation-1.jpg'
        },
      ],
      hemusArray: [
        {
          activation: 'hemus',
          title: 'АМ „Хемус“, участък от 78+500 до км 87+800',
          backbutton: 'АМ „Хемус“, участък от 78+500 до км 87+800',
          text: '- „Хидрорпо БГ“ се включи в строежа на новия 9,3 км. Участък на магистрала „ХЕМУС“. Автомагистралната отсечка ще бъде с по две ленти за движение в посока по 4 м, две ленти за спиране по 3 м, средна разделителна ивица - 2 м, водещи ивици и банкети. Участъкът е проектиран за експлоатационна скорост 140 км/ч. - На този обект са приложени специализиран поръчков каломаслоуловител.',
          products: [
            { name: 'Каломаслоуловител HYDROOIL DUO NS 400 l/s.', link: '/solution/hydrooil-duo' },
            { name: 'Спирално навити РЕ тръби с електромуфа ( 100 % водоплътност ) iD 500', link: '/solution/outflowpoints-revision' },
            { name: 'Ревизионни шахти РЕ – iD1000', link: '/solution/outflowpoints-revision' },
          ],
          thumbs: [
            { image: '/references/reference-hemus-1-thumb.jpg' },
            { image: '/references/reference-hemus-2-thumb.jpg' },
            { image: '/references/reference-hemus-3-thumb.jpg' },
            { image: '/references/reference-hemus-4-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-hemus-1.jpg' },
            { image: '/references/reference-hemus-2.jpg' },
            { image: '/references/reference-hemus-3.jpg' },
            { image: '/references/reference-hemus-4.jpg' },
          ],
          backgroundImage: '/references/Hemus-1-BG.jpg'
        },
      ],
      vitinyaArray: [
        {
          activation: 'vitinya',
          title: 'Тунел „Витиня“ - АМ „Хемус“',
          backbutton: 'Тунел „Витиня“',
          text: 'На 27- ми юни започна ремонтът на тунел „Витиня“ - АМ „Хемус“. Очаква се строителният обект да бъде готов през месец декември 2017. Ремонтните дейности включват възстановяване и усилване на тунелната облицовка, хидроизoлация, обновяване на пътната настилка, на електрическата и вентилационната инсталация, ново LED осветление, системи за видеонаблюдение и пожароизвестяване и др. На този обект са приложени специализирани поръчкови каломаслоуловители с байпасно устройство HYDROOIL BYPASS.',
          products: [
            { name: 'Каломаслоуловител HYDROOIL BYPASS NS 10-100 l/s.', link: '/solution/hydrooil-bypass' },
            { name: 'Каломаслоуловител HYDROOIL BYPASS NS 20-200 l/s.', link: '/solution/hydrooil-bypass' },
          ],
          thumbs: [
            { image: '/references/reference-vitinya-1-thumb.jpg' },
            { image: '/references/reference-vitinya-2-thumb.jpg' },
            { image: '/references/reference-vitinya-3-thumb.jpg' },
            { image: '/references/reference-vitinya-4-thumb.jpg' },
            { image: '/references/reference-vitinya-5-thumb.jpg' },
            { image: '/references/reference-vitinya-6-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-vitinya-1.jpg' },
            { image: '/references/reference-vitinya-2.jpg' },
            { image: '/references/reference-vitinya-3.jpg' },
            { image: '/references/reference-vitinya-4.jpg' },
            { image: '/references/reference-vitinya-5.jpg' },
            { image: '/references/reference-vitinya-6.jpg' },
          ],
          backgroundImage: '/references/Hemus-2-BG.jpg'
        },
      ],
      portburgasArray: [
        {
          activation: 'portburgas',
          title: 'Пристанище Бургас',
          backbutton: '„Пристанище Бургас” ЕАД',
          text: 'Държавният оператор „Пристанище Бургас” ЕАД е вторият по големина пристанищен оператор в бургаски пристанищен район Разполога с 14 корабни места, 1950 метра кейов фронт, 50 000 кв.м открити складови площи и 35 000 кв.м закрити складови площи. През 2018г. „Пристанище Бургас” стана на 115 години.',
          products: [
            { name: 'Тръба спирало навита PEHD с вградена електрозаваряема муфа ID900 SN14 / СТАНДАРТ ISO 9969' },
            { name: 'Тръба спирало навита PEHD с вградена електрозаваряема муфа ID700 SN14 / СТАНДАРТ ISO 9969' },
            { name: 'Тръба спирало навита PEHD с вградена електрозаваряема муфа ID500 SN14 / СТАНДАРТ ISO 9969' },
            { name: 'Каломаслоувител PEHD ID2000 H-4000, с вградени ревизионни отвори' },
          ],
          thumbs: [
            { image: '/references/reference-portburgas-1-thumb.jpg' },
            { image: '/references/reference-portburgas-2-thumb.jpg' },
            { image: '/references/reference-portburgas-3-thumb.jpg' },
            { image: '/references/reference-portburgas-4-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-portburgas-1.jpg' },
            { image: '/references/reference-portburgas-2.jpg' },
            { image: '/references/reference-portburgas-3.jpg' },
            { image: '/references/reference-portburgas-4.jpg' },
          ],
          backgroundImage: '/references/reference-portburgas-1.jpg'
        },
      ],
      strumaArray: [
        {
          activation: 'struma',
          title: 'АМ "Струма" ЛОТ 3.1',
          backbutton: 'АМ "Струма" ЛОТ 3.1',
          text: 'Участъкът на Лот 3.1 на АМ „Струма“ между Благоевград и Крупник е с дължина приблизително 13 км, а стойността на договора за проектиране и строителство е 185 999 999,90 лв. с ДДС, финансиран от Оперативна програма „Транспорт и транспортна инфраструктура“ 2014-2020 г. Предвижда се магистралното трасе да бъде с габарит А29 с две платна. Със строителството на Лот 3.1 на АМ „Струма“ ще се допринесе за устойчивото развитие на пътната инфраструктура на страната с национално, европейско и трансгранично значение, интегриране на националната транспортна мрежа  в европейската транспортна мрежа и постигане на баланс и развитие на връзките между различните видове транспорт.',
          products: [
            { name: 'Спирално навита тръба iD 630, SN 8 с фланец' },
            { name: 'Спирално навита трба iD 500, SN 4 с вградена ел. муфа' },
            { name: 'Каломаслоуловител NS 120 l/s. двусекционен' },
          ],
          thumbs: [
            { image: '/references/reference-struma-1-thumb.jpg' },
            { image: '/references/reference-struma-2-thumb.jpg' },
            { image: '/references/reference-struma-3-thumb.jpg' },
            { image: '/references/reference-struma-4-thumb.jpg' },
            { image: '/references/reference-struma-5-thumb.jpg' },
            { image: '/references/reference-struma-6-thumb.jpg' },
            { image: '/references/reference-struma-7-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-struma-1.jpg' },
            { image: '/references/reference-struma-2.jpg' },
            { image: '/references/reference-struma-3.jpg' },
            { image: '/references/reference-struma-4.jpg' },
            { image: '/references/reference-struma-5.jpg' },
            { image: '/references/reference-struma-6.jpg' },
            { image: '/references/reference-struma-7.jpg' },
          ],
          backgroundImage: '/references/reference-struma-bg.jpg'
        },
      ],

      vasillevskiArray: [
        {
          activation: 'vasil-levski',
          title: 'Обществен паркинг метростанция „Васил Левски“, гр. София',
          backbutton: 'Обществен паркинг метростанция „Васил Левски“',
          text: 'През 2018 г. обектът бе прехвърлен на ЦГМ и през декември бе избран изпълнител за довършителните дейности в лицето на „Калистратов груп“. Стойността на поръчка бе близо 3 млн. лв. Центърът за градска мобилност стопанисва 10 обществени надземни паркинга и 4 подземни буферни паркинги. Буферните паркинги са на метростанция „Джеймс Баучер” (577 паркоместа), на метростанция „Цариградско шосе” (1253 места) и два на метростанция „Бели Дунав“(съответно с 349 места и 118 места за паркиране). \n Капацитетът на подземния паркинг на метростанция ‘Стадион Васил Левски“ , който е на три нива е 193 места.',
          products: [
            { name: 'Каломаслоуловител NS 6 l/s.', link: '/solution/hydrooil-pro' },
          ],
          thumbs: [
            { image: '/references/reference-vasil-levski-1-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-vasil-levski-1.jpg' },
          ],
          backgroundImage: '/references/reference-vasil-levski-bg.jpg'
        },
      ],

      obzorArray: [
        {
          activation: 'obzor',
          title: 'Канализация гр. Обзор',
          backbutton: 'Канализация гр. Обзор',
          text: 'На 22 ноември 2012г.  в гр. Обзор бе направена първа копка по проект „Реконструкция на битова и дъждовна канализация и водопровод по ул. „Черноморска””. На събитието присъстваха кметът на община Несебър – Николай Димитров и кметът на гр. Обзор – Христо Янев. \nОбщата дължина на трасето е 881м., от което ще бъдат обновени битовата и дъждовната канализация, както и водопроводът. Заедно с тях ще бъдат пуснати и нови сградни отклонения. Предвидено е улицата да бъде пусната в експлоатация до началото на новия летен сезон, а общата стойност на проекта е 1, 300 000лв. с ДДС',
          products: [
            { name: 'Спирално навита тръба iD 500, SN 8 HDPE с вградена ел. муфа' },
          ],
          thumbs: [
            { image: '/references/reference-obzor-1-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-obzor-1.jpg' },
          ],
          backgroundImage: '/references/reference-obzor-bg.jpg'
        },
      ],

      gornabanyaArray: [
        {
          activation: 'gorna-banya',
          title: 'Изграждане на канализация на ул. „Н. Хрелков“, кв. Горна Баня, гр. София',
          backbutton: 'Изграждане на канализация на ул. „Н. Хрелков“',
          text: 'На 27.09.2016 г. беше подписан Протокол обр.2а за откриване на строителна площадка за строеж „Работен проект за водопроводна мрежа на кв.“Горна баня“ – кл. 27, 44, 43, 28, 161, 160, 178, Гл. кл. III, кл. 171, 169, 39, 40, 168, 153, 154, 23, 36, 29, 51, 62“ и др. \n Ще се изградят ВиК мрежи по ул.“Николай Хрелков“, бул.“Никола Петков“, ул.“757“, ул.“Гръсниче“, ул.“Синьо езеро“, ул.“Отдих“ и ул.“Извор“. Строително-монтажните работи ще започнат от бул.“Никола Петков“, в участъка от ул.“Ехо“ до ул.“Николай Хрелков“, където движението на МПС ще се извършва в едното пътно платно и ще се регулира със светофарна уредба',
          products: [
            { name: '-Спирално навита тръба iD 1200, SN 10 HDPE с вградена ел. муфа' },
          ],
          thumbs: [
            { image: '/references/reference-gorna-banya-1-thumb.jpg' },
            { image: '/references/reference-gorna-banya-2-thumb.jpg' },
            { image: '/references/reference-gorna-banya-3-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-gorna-banya-1.jpg' },
            { image: '/references/reference-gorna-banya-2.jpg' },
            { image: '/references/reference-gorna-banya-3.jpg' },
          ],
          backgroundImage: '/references/reference-gorna-banya-bg.jpg'
        },
      ],

      bojurishteArray: [
        {
          activation: 'bojurishte',
          title: 'Индустриална база Божурище',
          backbutton: 'Индустриална  база Божурище',
          text: 'Инвестиционният проект предвижда изграждане на предприятие за високотехнологично производство на части и модули за опаковъчни машини в Икономическа Зона София-Божурище, включващо производствен корпус, складова и логистична база, център за професионално обучение и квалификация и офисна част. Ще бъде разкрит и център за консултантски и споделени услуги в сферата на информационните  технологии и снабдяването. Машиностроителното предприятие е планирано да заработи след година  и предвижда разкриването на 153 нови работни места. \nВ първата си строителна фаза ще изгради завод с логистична база и административна част с разгъната площ 6500 кв.м. За строител е избрана българската компания Микс - Констръкшън, а проектният мениджър е IPS Group. ',
          products: [
            { name: 'Резервоар HDPE 82 m3 за противопожарни нужди', link: '/solution/tanks' },
          ],
          thumbs: [
            { image: '/references/reference-bojurishte-2-thumb.jpg' },
            { image: '/references/reference-bojurishte-1-thumb.jpg' },
            { image: '/references/reference-bojurishte-2-thumb.jpg' },
            { image: '/references/reference-bojurishte-1-thumb.jpg' },
            { image: '/references/reference-bojurishte-2-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-bojurishte-1.jpg' },
            { image: '/references/reference-bojurishte-2.jpg' },
            { image: '/references/reference-bojurishte-1.jpg' },
            { image: '/references/reference-bojurishte-2.jpg' },
            { image: '/references/reference-bojurishte-1.jpg' },
          ],
          backgroundImage: '/references/reference-bojurishte-bg.jpg'
        },
      ],

      gabrovoArray: [
        {
          activation: 'gabrovo',
          title: 'Обход на гр. Габрово и тунел под Шипка',
          backbutton: 'Обход на гр. Габрово и тунел под Шипка',
          text: 'Проект „Обход на гр. Габрово” – Фаза 1 - участък от км 0+000 до км 20+124.50 и етапна връзка от км 0+000 до км 3+130 \nОбходният път на гр. Габрово е част от Транс-европейски транспортен коридор №9 Букурещ - Русе - Димитровград - Александруполис и е възлова точка при движението на транспортните потоци в посока Север – Юг. Проектът се съфинансира от Кохезионния фонд на на ЕС и националния бюджет чрез ОП „Транспорт“ 2007 – 2013. Той включва строителството на участък от 23,25 км, етапна връзка на обхода със съществуващия път I-5 (3,1 км) и изработването на разширен идеен проект за тунел под връх Шипка. \n Основните транспортни направления, които ще обслужва обектът са: \n • Русе – Велико Търново – Шипка – Стара Загора – Свиленград (Маказа); \n • Оряхово – Севлиево – Шипка – Стара Загора – Свиленград (Маказа).',
          products: [
            { name: 'Резервоар HDPE 50 m3 за противопожарни нужди', link: '/solution/tanks' },
          ],
          thumbs: [
            { image: '/references/reference-gabrovo-1-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-gabrovo-1.jpg' },
          ],
          backgroundImage: '/references/reference-gabrovo-bg.jpg'
        },
      ],

      krunArray: [
        {
          activation: 'krun',
          title: 'Реконструкция на канализация на гр. Крън',
          backbutton: 'Реконструкция на канализация на гр. Крън',
          text: 'Дейностите по изпълнение на тази обществена поръчка включват: 1. Изготвяне на Работен проект за „Изграждане на ВиК инфраструктура за територията на град Крън“; 2. Изпълнение на строително-монтажни дейности във връзка с изграждане на ВиК инфраструктура на територията на град Крън, включително: — Изграждане на отвеждащ колектор за отпадъчни води от гр. Крън, — Изграждане на отливен канал от преливник до заустване в р. Кривата вада, — Изграждане на Главен клон I на канализационната мрежа на гр. Крън, — Изграждане на второстепенни канализационни клонове – гр. Крън, — Реконструкция на водопроводна мрежа в гр. Крън, 3. Авторски надзор по време на изпълнението на строително-монтажните дейности. \n За гарантиране на качественото и своевременно изпълнение на горните задължения, в договора за инженеринг е включена клауза за "възстановяване на неправомерно получени суми", както и обезпечение чрез издаването на банкова гаранция за добро изпълнение и банкова гаранция за периода на гаранционния срок посочен от участника.  \n Прогнозната (индикативната) стойност за изпълнението на дейностите по настоящата обществена поръчка е 12 371 691,11 лева без ДДС, разпределени по основни дейности, както следва: За изготвяне на работен проект - не повече от 300 000 лв. без ДДС; За изпълнение на строително-монтажни дейности във връзка с изграждане на ВиК инфраструктура на територията на град Крън, вкл. непредвидени разходи - не повече от 12 026 691,11 лв. без ДДС; За авторски надзор по време на изпълнението на строително-монтажните дейности - не повече от 45 000 лв. без ДДС.',
          products: [
            { name: '-Спирално навита трба iD 1600, SN 10 PP с резба и термосвиваема лента' },
          ],
          thumbs: [
            { image: '/references/reference-krun-1-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-krun-1.jpg' },
          ],
          backgroundImage: '/references/reference-krun-bg.jpg'
        },
      ],

      boyanaArray: [
        {
          activation: 'boyana',
          title: 'Многофамилна жилищна кооперация, кв. Бояна, гр. София',
          backbutton: 'Многофамилна жилищна кооперация',
          text: 'Обект, на който беше заложен един от новите ни продукти, а именно пречиствателна станция. Продукт създаден на база съществуващите норми и стандарти. Пречиствателната станция предлага отлично ниво на сепариране. \n Главен изпълнител на строителния обект е „ Калистратов груп“ ',
          products: [
            { name: 'Пречиствателна станция за 40 ЕЖ', link: '/solution/hydrooil-pro' },

          ],
          thumbs: [
            { image: '/references/reference-boyana-1-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-boyana-1.jpg' },
          ],
          backgroundImage: '/references/reference-boyana-bg.jpg'
        },
      ],
      bozhArray: [
        {
          activation: 'bozhurishte',
          title: 'Икономическа зона София - Божурище',
          backbutton: 'Икономическа зона София - Божурище',
          text: '-	Започва строителството на улици и канализация в Икономическа зона София – Божурище. Изпълнител е "Щрабаг" ЕАД. /n -	Haциoнaлнa ĸoмпaния индycтpиaлни зoни EAД избpa изпълнитeл зa пpoeĸтиpaнe пo вcичĸи чacти и cтpoитeлcтвo нa двyлeнтoвa yлицa №12, дъждoвнa ĸaнaлизaция и филтpaциoннa тpaншeя, битoвa ĸaнaлизaция, yличeн вoдoпpoвoд, paзпpeдeлитeлeн гaзoпpoвoд, тpъбeн пpexoд зa ĸaбeли 20 kV, тpъбнo тpace зa oптични ĸaбeли, yличнo ocвeтлeниe. Щe бъдe пpoeĸтиpaнa и pexaбилитaция нa двyлeнтoвa yлицa №15 c пapĸинг, ĸaтo щe ce cтpoи нoв yчacтъĸ c дължинa 70 м, oтвoднитeлнa ĸaнaлизaция и yличнo ocвeтлeниe зa yлицa 15, ĸaĸтo и нa yчacтъĸ oт yлицa 13. Щe бъдaт пocтaвeни пътни знaци, мapĸиpoвĸa и oзeлeнявaнe в oбxвaтa нa peгyлaциятa нa yлицa 12 и 15. Oбeĸтитe ca Иĸoнoмичecĸa зoнa Coфия-Бoжypищe, oбщинa Бoжypищe нa Coфийcĸa oблacт. /n-	Cтoйнocттa нa пopъчĸaтa e 1 609 318.48 лв. бeз ДДC (1 931 182 лв. c ДДC), ĸaтo индиĸaтивнaтa cтoйнocт e билa 1.5 млн. лв. Дoгoвopът зa пpoeĸтиpaнe и cтpoитeлcтвo e cĸлючeн нa 8 мapт.',
          products: [
            { name: 'Спирално навита тръба SPEC iD 200, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 300, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 400, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 500, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 600, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 700, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 800, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 900, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 1100, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 1200, SN 10 с вградена ел. муфа' },
            { name: 'Спирално навита тръба SPEC iD 1300, SN 10 с вградена ел. муфа' },

          ],
          thumbs: [
            { image: '/references/reference-bozhurishte-thumb-1.jpg' },
            { image: '/references/reference-bozhurishte-thumb-2.jpg' },
            { image: '/references/reference-bozhurishte-thumb-3.jpg' },
            { image: '/references/reference-bozhurishte-thumb-4.jpg' },
            { image: '/references/reference-bozhurishte-thumb-5.jpg' },
            { image: '/references/reference-bozhurishte-thumb-6.jpg' },
            { image: '/references/reference-bozhurishte-thumb-7.jpg' },
            { image: '/references/reference-bozhurishte-thumb-8.jpg' },
            { image: '/references/reference-bozhurishte-thumb-9.jpg' },
            { image: '/references/reference-bozhurishte-thumb-10.jpg' },
            { image: '/references/reference-bozhurishte-thumb-11.jpg' },
          ],
          images: [
            { image: '/references/reference-bozhurishte-thumb-1.jpg' },
            { image: '/references/reference-bozhurishte-thumb-2.jpg' },
            { image: '/references/reference-bozhurishte-thumb-3.jpg' },
            { image: '/references/reference-bozhurishte-thumb-4.jpg' },
            { image: '/references/reference-bozhurishte-thumb-5.jpg' },
            { image: '/references/reference-bozhurishte-thumb-6.jpg' },
            { image: '/references/reference-bozhurishte-thumb-7.jpg' },
            { image: '/references/reference-bozhurishte-thumb-8.jpg' },
            { image: '/references/reference-bozhurishte-thumb-9.jpg' },
            { image: '/references/reference-bozhurishte-thumb-10.jpg' },
            { image: '/references/reference-bozhurishte-thumb-11.jpg' },
           
          ],
          backgroundImage: '/references/reference-boyana-bg.jpg'
        },
      ],

      missingArray: [
        {
          activation: 'missing',
          title: 'Липсваща референция',
          backbutton: 'Назад',
          text: 'Няма информация за тази референция.',
          products: [
            { name: '-' },
          ],
          thumbs: [
            { image: '/references/reference-missing-1-thumb.jpg' },
          ],
          images: [
            { image: '/references/reference-missing-1.jpg' },
          ],
          backgroundImage: '/references/reference-missing-bg.jpg'
        },
      ],

    }
  }

  componentDidMount() {
    switch (this.props.match.params.name) {
      case 'rehabilitation':
        this.setState({ selectedArray: this.state.rehabilitationArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'hemus':
        this.setState({ selectedArray: this.state.hemusArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'vitinya':
        this.setState({ selectedArray: this.state.vitinyaArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'portburgas':
        this.setState({ selectedArray: this.state.portburgasArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'struma':
        this.setState({ selectedArray: this.state.strumaArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'vasil-levski':
        this.setState({ selectedArray: this.state.vasillevskiArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'obzor':
        this.setState({ selectedArray: this.state.obzorArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'gorna-banya':
        this.setState({ selectedArray: this.state.gornabanyaArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'bojurishte':
        this.setState({ selectedArray: this.state.bojurishteArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'gabrovo':
        this.setState({ selectedArray: this.state.gabrovoArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'krun':
        this.setState({ selectedArray: this.state.krunArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'boyana':
        this.setState({ selectedArray: this.state.boyanaArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
      case 'bozhurishte':
        this.setState({ selectedArray: this.state.bozhArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;

      default:
        this.setState({ selectedArray: this.state.missingArray }, () => { this.setState({ selectedImage: this.state.selectedArray[0].images[0].image }) })
        break;
    }

  }
  render() {

    function imageChange(index) {
      this.setState({ selectedImage: this.state.selectedArray[0].images[index].image, selectedThumbnail: { index } }, selectThumbnail.bind(this, index))
      //console.log(this.state.selectedArray[0].products[1].name)
    }
    function selectThumbnail(index) {
      this.setState({ selectedThumbnail: { index }.index })
    }

    const thumbnails = this.state.selectedArray[0].thumbs.map((thumbs, index) =>
      <div key={index}>
        <div className={index === this.state.selectedThumbnail ? 'thumb thumb-selected' : 'thumb'}><div id={index} onClick={imageChange.bind(this, index)} style={{ backgroundImage: 'url(' + thumbs.image + ')' }}><img src='/imgs/blank.gif' alt='' /></div></div>
      </div>
    )

    const products = this.state.selectedArray[0].products.map((products, k) =>
      <div key={k} id={'product' + k}>
        <Link to={products.link}> {products.name}</Link></div>
    )

    const settings = {
      className: "slider variable-width",
      dots: false,
      infinite: true,
      // centerMode: false,
      // slidesToScroll: 3,
      // slidesToShow: 3,
      variableWidth: true,
      // focusOnSelect: true,
      // initialSlide: 0,
      speed: 800,
    };
    return (
      <div className='reference page-bg' id='reference-page' style={{ backgroundImage: 'url(' + this.state.selectedImage + ')' }}>
        {/* <div className='reference page-bg' id='reference-page' style={{ backgroundImage: 'url(' + this.state.selectedArray[0].backgroundImage + ')' }}> */}
        <div className='container'>
          <ShrinkBox
            title={this.state.selectedArray[0].title}
            text={this.state.selectedArray[0].text}
            backbutton={this.state.selectedArray[0].backbutton}
            products={products}
          />
          <div className='gallery-slider-thumbs'>
            <Slider {...settings} >
              {thumbnails}
            </Slider>
          </div>
        </div>
      </div>);
  }
}

export default ReferenceDesktop;